import React from 'react';
import { useIsBuyer } from '@/utils/hooks';
import { CustomRedirect } from '@/components/navigation';
import NotFound from '@/components/error-pages/NotFound';

const ExternalLinksRoutingChangeRequestOffer: React.FC<{ changeRequestId: number }> = ({ changeRequestId }) => {
    const isBuyer = useIsBuyer();

    if (isBuyer) {
        return <CustomRedirect to={`/change-requests/${changeRequestId}/offer`} />;
    }

    return <NotFound />;
};

export default ExternalLinksRoutingChangeRequestOffer;